import { render, staticRenderFns } from "./WizardResult.vue?vue&type=template&id=584e1974"
import script from "./WizardResult.vue?vue&type=script&lang=js"
export * from "./WizardResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports